import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await api.post("/admin/login", { email, password });
            localStorage.setItem("vvs_admin_token", r.data.token);
            navigate("/admin");
        } catch {
            toast.error("Identifiants invalides");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
            <form onSubmit={submit} className="glass-card rounded-2xl p-8 w-full max-w-md space-y-4">
                <div className="text-center mb-6">
                    <div className="font-serif-luxe text-2xl tracking-[0.2em] chrome-text">VVS HÉRITAGE</div>
                    <div className="text-xs uppercase tracking-widest text-slate-500 mt-2">Back-office</div>
                </div>
                <div>
                    <label>Courriel</label>
                    <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div>
                    <label>Mot de passe</label>
                    <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
                <button data-testid="admin-login-submit-btn" type="submit" disabled={loading} className="btn-primary w-full">
                    {loading ? "Connexion…" : "Se connecter"}
                </button>
            </form>
        </div>
    );
}
